import { ButtonBase } from './ButtonBase';
import styled from 'styled-components';

export const PrimaryButton = styled(ButtonBase)`
  background: #2c2c2c;
  color: #fff;
  border-radius: 4px;
`;
